"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** This function allows components to accept data-props
 * As well as mouse-enter and mouse-leave events and forward refs
 */
var allowedProps = ['data-', 'onMouseEnter', 'onMouseLeave', 'forwardedRef', 'aria-', 'role'];

var allowedKey = function allowedKey(key) {
  return allowedProps.reduce(function (allowed, prop) {
    return allowed || key.startsWith(prop);
  }, false);
};

function _default(props) {
  return Object.keys(props).filter(function (key) {
    return allowedKey(key);
  }).reduce(function (obj, key) {
    var prop = key === 'forwardedRef' ? 'ref' : key;
    return _objectSpread({}, obj, _defineProperty({}, prop, props[key]));
  }, {});
}